__turbopack_context__.v({
  "bgCard1": "StatusCardModal-module-scss-module__f9NI7G__bgCard1",
  "bgCard2": "StatusCardModal-module-scss-module__f9NI7G__bgCard2",
  "bgCard3": "StatusCardModal-module-scss-module__f9NI7G__bgCard3",
  "cardImage": "StatusCardModal-module-scss-module__f9NI7G__cardImage",
  "cardTop": "StatusCardModal-module-scss-module__f9NI7G__cardTop",
  "desc": "StatusCardModal-module-scss-module__f9NI7G__desc",
  "statusPic": "StatusCardModal-module-scss-module__f9NI7G__statusPic",
});
